module.exports = __webpack_public_path__ + "static/media/2 7 tattoo arm sleeve snake raven illustrative monochromatic dynamic.1280x2276.0ef5594d.webp";